import { useTranslation } from 'react-i18next';
import { Button, IconStartAdornment } from 'components/Button';
import { DocumentTitle } from 'components/DocumentTitle';
import { DisplayTimezoneProvider } from 'domains/timezone/useDisplayTimezone';
import { SignupContext } from 'domains/signup/signupFlow/context/signupContext';
import { SignupEnterTarget } from 'domains/signup/sharedSteps/EnterTarget';
import { SignupEnteringInsurance } from 'domains/signup/signupFlow/Steps/EnteringInsurance';
import { SignupEnteringContactInfo } from 'domains/signup/signupFlow/Steps/EnteringContactInfo';
import { SignupEnterCommunicationConcerns } from 'domains/signup/signupFlow/Steps/EnterCommunicationConcerns';
import { SignupEnteringSchedule } from 'domains/signup/signupFlow/Steps/EnteringSchedule';
import { SignupErrorDuplicate } from 'domains/signup/signupFlow/Steps/Error';
import { SignupLoadingStep } from 'domains/signup/sharedSteps/LoadingStep';

const BaseSignUpMachineWrapper: React.FC = () => {
  const { t } = useTranslation();

  const hasBack = SignupContext.useSelector(state => state.can({ type: 'back' }));
  const { send } = SignupContext.useActorRef();

  return (
    <div className="flex flex-col min-h-full items-center px-24 md:px-0">
      <DocumentTitle>{t('screener.pageTitle')}</DocumentTitle>

      <div className="max-w-[600px] w-full min-h-full self-center py-64 sm-d:py-40">
        {hasBack && (
          <Button
            variant="link"
            startAdornment={<IconStartAdornment name="AngleLeft" />}
            className="mb-24"
            onClick={() =>
              send({
                type: 'back',
              })
            }
          >
            {t('screener.backButton')}
          </Button>
        )}

        <SignupEnterTarget />

        <SignupEnterCommunicationConcerns />

        <SignupEnteringContactInfo />

        <SignupEnteringInsurance />

        <DisplayTimezoneProvider>
          <SignupEnteringSchedule />
        </DisplayTimezoneProvider>

        <SignupLoadingStep />
        <SignupErrorDuplicate />
      </div>
    </div>
  );
};

export default BaseSignUpMachineWrapper;
